import Headroom from 'headroom.js';

const init = () => {
  const myElement = document.querySelector('body');
  const headroom = new Headroom(myElement);
  headroom.init();
};

export default init;
